import { East } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React from "react";

type LinkProps = {
  url: string;
};

export const Link = ({ url }: LinkProps) => {
  return (
    <Box display="flex">
      <Box
        display="flex"
        alignItems="center"
        gap={10}
        onClick={() => window.open(url, "_blank")}
        sx={{
          borderBottom: "1px solid rgba(255, 255, 255, 0.6)",
          paddingBottom: "2px",
          cursor: "pointer",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            opacity: 0.6,
            fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" },
          }}
        >
          View here
        </Typography>
        <East color="inherit" sx={{ color: "#ffffff", opacity: 0.6 }} />
      </Box>
    </Box>
  );
};
